import React from "react";
import "./Jumbotron.scss";

const Jumbotron = () => (
    <section id="jumbotron-name-desc-section" className="section-wrapper">
        <div className="section-inner" id="jumbotron-name-desc-wrapper">
            <div className="html-tags-jumbotron develop-text">
                <span>&lt;body&gt;</span>
                <span className="html-tags-jumbotron-indent-1">&lt;h1&gt;</span>
            </div>
            <div className="main-text-container">
                <h1 id="main-name-highlight">Kayleigh Schlupp</h1>
            </div>
            <div className="html-tags-jumbotron develop-text">
                <span className="html-tags-jumbotron-indent-1">&lt;&#47;h1&gt;</span>
                <span className="html-tags-jumbotron-indent-1">&lt;h2&gt;</span>
            </div>
            <div className="main-text-container">
                <h2 id="main-description-row">
                    <span className="develop-text main-description-text">&lt;Developer&gt;</span>
                    <span className="main-description-text">&</span>
                    <span className="design-text main-description-text">Designer</span>
                </h2>
            </div>
            <div className="html-tags-jumbotron develop-text">
                <span style={{ paddingLeft: "20px" }}>&lt;&#47;h2&gt;</span>
                <span>&lt;&#47;body&gt;</span>
            </div>
        </div>
        <div id="jumbotron-bottom-border" aria-hidden="true">
            <svg
                width="393"
                height="51"
                viewBox="0 0 393 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
            >
                <path d="M0 12.8704L392.808 5.51587L393 50.746L5.04454e-06 16.9153L0 12.8704Z" fill="var(--action)" />
                <path d="M2.14753e-06 0L393 34.0642V51L2.10487e-06 16.9358L2.14753e-06 0Z" fill="var(--primary)" />
                <path d="M2.14753e-06 0L393 33.0952V46.8287L5.50243e-07 12.7644L2.14753e-06 0Z" fill="var(--action)" fillOpacity="0.5" />
            </svg>
        </div>
    </section>
)

export default Jumbotron;